package com.iregained.eventapp.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth

// Explicit absolute route mapping ensures zero conflict with the root Index.kt
@Page("/admin")
@Composable
fun AdminIndexPage() {
    val ctx = rememberPageContext()

    LaunchedEffect(Unit) {
        // Check if the user is already authenticated
        val currentUser = Firebase.auth.currentUser

        if (currentUser != null) {
            // User is logged in, take them to the dashboard
            ctx.router.navigateTo("/admin/dashboard")
        } else {
            // User is not logged in, force them to the login page
            ctx.router.navigateTo("/admin/login")
        }
    }

    // Show a simple loading state while the redirect happens instantly
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        SpanText("Loading Staff Portal...")
    }
}